(() => {
  if (window.__MTS_SIZE_QUIZ_DRAWER_V2__) return;
  window.__MTS_SIZE_QUIZ_DRAWER_V2__ = true;

  const SIZES = ["S", "M", "L", "XL", "XXL"];
  const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
  const qs = (r, s) => r.querySelector(s);
  const qsa = (r, s) => Array.from(r.querySelectorAll(s));

  // =========================================
  // 1) Algo recommandation simple (stable)
  // =========================================
  function sizeFromProfile(heightCm, weightKg, fit) {
    const h = heightCm / 100;
    const bmi = weightKg / (h * h);
    let score = bmi + (heightCm - 175) / 40;

    let idx =
      score < 22 ? 0 :
      score < 25 ? 1 :
      score < 28 ? 2 :
      score < 31 ? 3 : 4;

    if (fit === "slim") idx -= 1;
    if (fit === "loose") idx += 1;
    idx = clamp(idx, 0, SIZES.length - 1);

    const centers = [21, 24, 27, 30, 33];
    const d = Math.min(6, Math.abs(score - centers[idx]));
    const confidence = Math.round(clamp(98 - d * 6, 78, 98));

    const text =
      fit === "slim"
        ? "Tu as choisi un rendu ajusté : plus près du corps."
        : fit === "loose"
        ? "Tu as choisi un rendu large : plus confort."
        : "La majorité des personnes avec un profil similaire choisissent cette taille.";

    return { size: SIZES[idx], confidence, text };
  }

  // =========================================
  // 2) Appliquer la taille au formulaire produit
  //    Fix 2026-05-30: supporte les boutons MTS custom (.mts-size-btn[data-value])
  //    + select natif + radios + labels. Highlight visuel + scroll vers ATC.
  // =========================================
  function applySizeToProductForm(widget, size) {
    const wantedUpper = String(size || "").trim().toUpperCase();
    if (!wantedUpper) return false;

    // Try the entire document — drawers can move overlay outside the section
    const scopes = [
      widget.closest("section, .shopify-section, main, body"),
      document
    ].filter(Boolean);

    let applied = false;

    for (const scope of scopes) {
      if (applied) break;

      // ---- 1) MTS custom size buttons (PDP main product) ----
      const mtsBtns = qsa(scope, '.mts-size-buttons[data-option="size"] .mts-size-btn, .mts-size-buttons:not([data-option="short-size"]) .mts-size-btn');
      for (const btn of mtsBtns) {
        const val = String(btn.getAttribute("data-value") || btn.textContent || "").trim().toUpperCase();
        if (!val) continue;
        if (val === wantedUpper) {
          btn.click();
          btn.scrollIntoView({ block: "center", behavior: "smooth" });
          btn.classList.add("mts-size-btn--applied");
          setTimeout(() => btn.classList.remove("mts-size-btn--applied"), 1400);
          applied = true;
          break;
        }
      }
      if (applied) break;

      // ---- 2) Native <select name="options[Taille]"> ----
      const selects = qsa(scope, 'select[name^="options"], select[name*="options"]');
      for (const sel of selects) {
        const name = (sel.getAttribute("name") || "").toLowerCase();
        if (name.includes("taille") || name.includes("size")) {
          const opt = Array.from(sel.options).find(o => (o.value || "").trim().toUpperCase() === wantedUpper);
          if (opt) {
            sel.value = opt.value;
            sel.dispatchEvent(new Event("change", { bubbles: true }));
            sel.dispatchEvent(new Event("input", { bubbles: true }));
            applied = true;
            break;
          }
        }
      }
      if (applied) break;

      // ---- 3) Radios <input type="radio" name="Taille-1" ...> (Foxtheme button picker) ----
      const radios = qsa(scope, 'input[type="radio"]');
      for (const r of radios) {
        const val = String(r.value || "").trim().toUpperCase();
        const name = String(r.getAttribute("name") || "").toLowerCase();
        if (val !== wantedUpper) continue;
        if (name.includes("taille") || name.includes("size") || name.startsWith("options")) {
          r.checked = true;
          r.dispatchEvent(new Event("change", { bubbles: true }));
          r.dispatchEvent(new Event("input", { bubbles: true }));
          applied = true;
          break;
        }
      }
      if (applied) break;

      // ---- 4) Labels fallback (text match) ----
      const labels = qsa(scope, "label, button");
      for (const lab of labels) {
        const t = (lab.textContent || "").trim().toUpperCase();
        if (t === wantedUpper) {
          lab.click();
          applied = true;
          break;
        }
      }
    }

    // Highlight ATC button + scroll into view to confirm action
    try {
      const atcSelectors = [
        '#mts-add-to-cart',
        '.mts-add-to-cart',
        'button[name="add"]',
        '.product-form__submit',
        '[data-action="add-to-cart"]'
      ];
      for (const sel of atcSelectors) {
        const atc = document.querySelector(sel);
        if (atc) {
          atc.scrollIntoView({ block: "center", behavior: "smooth" });
          atc.classList.add("mts-atc--pulse");
          setTimeout(() => atc.classList.remove("mts-atc--pulse"), 1600);
          break;
        }
      }
    } catch (e) {}

    return applied;
  }

  // =========================================
  // 3) Scroll lock (mobile safe)
  // =========================================
  let savedScrollY = 0;
  function lockScroll(lock) {
    if (lock) {
      savedScrollY = window.scrollY || 0;
      document.body.style.position = "fixed";
      document.body.style.top = `-${savedScrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
      document.body.style.width = "100%";
    } else {
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      document.body.style.width = "";
      window.scrollTo(0, savedScrollY);
    }
  }

  // =========================================
  // 4) Gestion globale : un seul drawer ouvert à la fois
  // =========================================
  let ACTIVE = null;
  function closeActive() {
    if (ACTIVE && typeof ACTIVE.close === "function") ACTIVE.close();
  }

  // =========================================
  // 5) Init d'un widget
  // =========================================
  function initOne(widget) {
    const btnOpen = qs(widget, "[data-mts-sq-open]");
    const overlay = qs(widget, "[data-mts-sq-overlay]");
    const panel = qs(widget, "[data-mts-sq-panel]");
    const btnClose = qs(widget, "[data-mts-sq-close]");
    const btnBack = qs(widget, "[data-mts-sq-back]");
    const bar = qs(widget, "[data-mts-sq-bar]");

    const heightR = qs(widget, "[data-mts-sq-height]");
    const weightR = qs(widget, "[data-mts-sq-weight]");
    const hVal = qs(widget, "[data-mts-sq-height-val]");
    const wVal = qs(widget, "[data-mts-sq-weight-val]");

    const fitBtns = qsa(widget, "[data-mts-sq-fit]");
    const btnNexts = qsa(widget, "[data-mts-sq-next]");
    const btnApply = qs(widget, "[data-mts-sq-apply]");
    const btnRestart = qs(widget, "[data-mts-sq-restart]");

    const outSize = qs(widget, "[data-mts-sq-result-size]");
    const outConf = qs(widget, "[data-mts-sq-result-confidence]");
    const outText = qs(widget, "[data-mts-sq-result-text]");

    const steps = qsa(widget, ".mts-sq__step");

    if (!overlay || !panel) return;

    const overlayAnchor = document.createComment("mts-sq-overlay-anchor");
    const panelAnchor = document.createComment("mts-sq-panel-anchor");
    overlay.parentNode.insertBefore(overlayAnchor, overlay);
    panel.parentNode.insertBefore(panelAnchor, panel);

    overlay.hidden = true;
    panel.hidden = true;
    panel.classList.remove("is-open");

    let step = 0;
    let fit = "regular";
    let isOpen = false;

    function showStep(n) {
      step = n;
      steps.forEach(s => (s.hidden = s.getAttribute("data-step") !== String(step)));
      if (btnBack) btnBack.hidden = step <= 0;
      if (bar) bar.style.width = `${Math.round((step / 4) * 100)}%`;
    }

    function computeAndRender() {
      const h = Number(heightR?.value || 175);
      const w = Number(weightR?.value || 70);
      const res = sizeFromProfile(h, w, fit);

      if (outSize) outSize.textContent = res.size;
      if (outConf) outConf.textContent = String(res.confidence);
      if (outText) outText.textContent = res.text;

      try {
        localStorage.setItem("mts_size_quiz", JSON.stringify({ height: h, weight: w, fit, ...res, ts: Date.now() }));
      } catch (e) {}

      return res;
    }

    function moveToBodyForTopLayer() {
      if (overlay.parentNode !== document.body) document.body.appendChild(overlay);
      if (panel.parentNode !== document.body) document.body.appendChild(panel);
    }

    function restoreToAnchors() {
      if (overlayAnchor.parentNode) overlayAnchor.parentNode.insertBefore(overlay, overlayAnchor.nextSibling);
      if (panelAnchor.parentNode) panelAnchor.parentNode.insertBefore(panel, panelAnchor.nextSibling);
    }

    function open() {
      if (isOpen) return;
      closeActive();
      isOpen = true;
      ACTIVE = api;

      moveToBodyForTopLayer();
      overlay.hidden = false;
      panel.hidden = false;

      panel.style.transition = "";
      panel.style.transform = "";
      overlay.style.opacity = "";

      lockScroll(true);

      requestAnimationFrame(() => {
        panel.classList.add("is-open");
      });

      panel.setAttribute("aria-hidden", "false");
      overlay.setAttribute("aria-hidden", "false");

      showStep(0);

      setTimeout(() => {
        const focusable = panel.querySelector("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
        if (focusable) focusable.focus({ preventScroll: true });
      }, 50);
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;

      panel.classList.remove("is-open");
      lockScroll(false);

      setTimeout(() => {
        overlay.hidden = true;
        panel.hidden = true;

        panel.style.transform = "";
        panel.style.transition = "";
        overlay.style.opacity = "";

        restoreToAnchors();

        if (ACTIVE === api) ACTIVE = null;
      }, 260);
    }

    const api = { open, close };

    btnOpen?.addEventListener("click", (e) => {
      e.preventDefault();
      open();
    });

    btnClose?.addEventListener("click", (e) => {
      e.preventDefault();
      close();
    });

    overlay.addEventListener("click", () => close());

    if (!window.__MTS_SQ_ESC__) {
      window.__MTS_SQ_ESC__ = true;
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") closeActive();
      });
    }

    btnBack?.addEventListener("click", () => showStep(Math.max(0, step - 1)));

    btnNexts.forEach((b) =>
      b.addEventListener("click", () => {
        if (step === 3) {
          computeAndRender();
          showStep(4);
        } else {
          showStep(Math.min(4, step + 1));
        }
      })
    );

    heightR?.addEventListener("input", () => {
      if (hVal) hVal.textContent = heightR.value;
    });

    weightR?.addEventListener("input", () => {
      if (wVal) wVal.textContent = weightR.value;
    });

    fitBtns.forEach((b) =>
      b.addEventListener("click", () => {
        fitBtns.forEach((x) => x.classList.remove("is-active"));
        b.classList.add("is-active");
        fit = b.getAttribute("data-mts-sq-fit") || "regular";

        if (step === 3) {
          computeAndRender();
          showStep(4);
        }
      })
    );

    btnRestart?.addEventListener("click", () => showStep(0));

    // =========================================
    // FIX 2026-05-30: bouton "Appliquer la taille"
    // - Si on est sur la home (pas de PDP), on persiste + on redirige vers /collections/tous-nos-maillots
    //   avec un flash pour signaler que la taille est sauvegardée
    // - Si on est sur une PDP, on applique direct + on ferme le drawer
    // =========================================
    btnApply?.addEventListener("click", () => {
      const res = computeAndRender();
      const ok = applySizeToProductForm(widget, res.size);

      if (!ok) {
        // Pas de PDP — taille persistée, message + close
        try {
          btnApply.textContent = "✓ Taille enregistrée";
        } catch (e) {}
        if (outText) {
          outText.textContent = "Ta taille (" + res.size + ") est enregistrée. Elle s'appliquera automatiquement sur le maillot que tu choisiras.";
        }
        setTimeout(() => {
          try { btnApply.textContent = "Appliquer la taille"; } catch (e) {}
          close();
        }, 1600);
        return;
      }

      try {
        btnApply.textContent = "✓ Taille appliquée";
        setTimeout(() => { btnApply.textContent = "Appliquer la taille"; }, 1200);
      } catch (e) {}
      close();
    });

    // =========================================
    // Swipe down pour fermer (mobile)
    // =========================================
    let startY = 0;
    let curY = 0;
    let dragging = false;

    panel.addEventListener(
      "touchstart",
      (e) => {
        if (!isOpen) return;
        const body = panel.querySelector(".mts-sq__body");
        if (body && body.scrollTop > 0) return;

        dragging = true;
        startY = e.touches[0].clientY;
        curY = startY;

        panel.style.transition = "none";
      },
      { passive: true }
    );

    panel.addEventListener(
      "touchmove",
      (e) => {
        if (!dragging || !isOpen) return;

        curY = e.touches[0].clientY;
        const dy = Math.max(0, curY - startY);

        panel.style.transform = `translate3d(0, ${dy}px, 0)`;

        const op = clamp(1 - dy / 260, 0.35, 1);
        overlay.style.opacity = String(op);
      },
      { passive: true }
    );

    panel.addEventListener("touchend", () => {
      if (!dragging || !isOpen) return;
      dragging = false;

      const dy = Math.max(0, curY - startY);

      panel.style.transition = "";
      panel.style.transform = "";
      overlay.style.opacity = "";

      if (dy > 110) {
        close();
      } else {
        panel.classList.add("is-open");
      }
    });

    // Restore saved values (optionnel)
    try {
      const saved = JSON.parse(localStorage.getItem("mts_size_quiz") || "null");
      if (saved) {
        if (heightR) {
          heightR.value = saved.height || 175;
          if (hVal) hVal.textContent = heightR.value;
        }
        if (weightR) {
          weightR.value = saved.weight || 70;
          if (wVal) wVal.textContent = weightR.value;
        }
        if (saved.fit) {
          fit = saved.fit;
          fitBtns.forEach((x) =>
            x.classList.toggle("is-active", x.getAttribute("data-mts-sq-fit") === fit)
          );
        }
      }
    } catch (e) {}

    showStep(0);
  }

  // =========================================
  // FIX 2026-05-30 (Bug 1.A) — Auto-apply saved size on PDP load
  // Améliorations vs version précédente :
  //   - MAX_TRIES augmenté à 40 (au lieu de 10) — couvre les apps async lourdes (Globo)
  //   - POLL_INTERVAL plus court : 250ms au début, 500ms ensuite
  //   - MutationObserver actif : détecte l'apparition tardive des boutons size
  //   - Détection PDP plus robuste (URL pattern + DOM markers + multi-selectors)
  //   - Cleanup propre quand applied OU après 20s safety
  // =========================================
  function autoApplyOnPdp() {
    try {
      // Détection PDP : URL pattern OU DOM markers
      const isPdpUrl = /\/products\//.test(location.pathname);
      const isPdpDom = !!document.querySelector(
        '.mts-size-buttons[data-option="size"], ' +
        'select[name*="Taille"], select[name*="taille"], ' +
        'input[name*="Taille"], input[name*="taille"], ' +
        'form[action*="/cart/add"]'
      );
      if (!isPdpUrl && !isPdpDom) return;

      const saved = JSON.parse(localStorage.getItem("mts_size_quiz") || "null");
      if (!saved || !saved.size) return;

      // Skip if quiz data is too old (> 30 days) — éviter d'appliquer une taille périmée
      if (saved.ts && (Date.now() - saved.ts) > 30 * 24 * 3600 * 1000) {
        try { localStorage.removeItem("mts_size_quiz"); } catch (e) {}
        return;
      }

      const pageKey = "mts_size_quiz_applied_" + location.pathname;
      if (sessionStorage.getItem(pageKey)) return;

      let tries = 0;
      const MAX_TRIES = 40;
      let mo = null;
      let safetyTimeout = null;
      let applied = false;
      let lastTryTs = 0;

      const cleanup = () => {
        if (mo) { try { mo.disconnect(); } catch (e) {} mo = null; }
        if (safetyTimeout) { clearTimeout(safetyTimeout); safetyTimeout = null; }
      };

      const tryApply = () => {
        if (applied) { cleanup(); return; }

        // Throttle : pas plus d'un essai par 150ms (évite spam via MutationObserver)
        const now = Date.now();
        if (now - lastTryTs < 150) return;
        lastTryTs = now;

        tries++;

        // Vérifie si les boutons size sont maintenant dans le DOM
        const hasSizeUi = !!document.querySelector(
          '.mts-size-buttons[data-option="size"] .mts-size-btn, ' +
          '.mts-size-buttons:not([data-option="short-size"]) .mts-size-btn, ' +
          'select[name*="Taille"] option, select[name*="taille"] option, ' +
          'input[name*="Taille"], input[name*="taille"]'
        );

        if (!hasSizeUi) {
          // Pas encore prêt — la MutationObserver re-déclenchera tryApply
          if (tries >= MAX_TRIES) cleanup();
          return;
        }

        const ok = applySizeToProductForm(document.body, saved.size);
        if (ok) {
          applied = true;
          try { sessionStorage.setItem(pageKey, "1"); } catch (e) {}
          cleanup();
        } else if (tries >= MAX_TRIES) {
          cleanup();
        }
      };

      // Premier essai après 200ms (le temps que le DOM initial soit setup)
      setTimeout(tryApply, 200);

      // MutationObserver pour détecter l'apparition tardive des boutons size
      try {
        mo = new MutationObserver(() => {
          if (applied) { cleanup(); return; }
          tryApply();
        });
        mo.observe(document.body, { childList: true, subtree: true });
      } catch (e) {}

      // Safety net : disconnect après 25s même si pas appliqué (Globo très lent)
      safetyTimeout = setTimeout(() => {
        cleanup();
      }, 25000);

      // Polling backup léger : retry toutes les 500ms en parallèle du MutationObserver
      let pollTries = 0;
      const pollInterval = setInterval(() => {
        pollTries++;
        if (applied || pollTries >= 50) {
          clearInterval(pollInterval);
          return;
        }
        tryApply();
      }, 500);
    } catch (e) {}
  }

  function boot() {
    document.querySelectorAll("[data-mts-size-quiz]").forEach(initOne);
    autoApplyOnPdp();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
